define(['jquery', 'common', 'scrollto'], function ($, Common) {
	var Tabs = function () {
		var self = this;
		self.$ervBody = $('#erv-body');
		self.common = new Common();

		self.setActiveTabAndContent = function ($tabContainer, $link) {
			//set active tab
			var $activeTabMenuItem = $tabContainer.find('.tabs-container li.active');
			$activeTabMenuItem.removeClass('active');
			$link.parent().addClass('active');

			//set active content
			var $tabContents = $tabContainer.find('.tab-content');
			$tabContents.addClass('hide');

			var hashNumber = $link.attr('href').split('#tab-')[1],
				elementIndex = Number(hashNumber) - 1,
				matchingContent = $tabContents.get(elementIndex);

			if (typeof (matchingContent) !== 'undefined') {
				$(matchingContent).removeClass('hide');
				if (window.history) {
					window.history.replaceState(null, null, ' ');
				}
			}
		};

		self.initTabsEventHandlers = function () {
			self.$tabs = self.$ervBody.find('.tabs').first();

			self.setupTabs(self.$tabs);

			if (self.$tabs.length === 0) { return false; }
			
			self.$tabs.find('.tabs-container li a').each(function () {
				var $link = $(this);

				$link.on('click', function (e) {
					e.preventDefault();
					e.stopPropagation();
					self.setActiveTabAndContent(self.$tabs, $link);
					//additional menu hide
					var $flexIsExpanded = self.$tabs.find('.is-expanded');
					$flexIsExpanded.removeClass('is-expanded');
				});
			});
		};

		self.setupHash = function () {
			self.$tabs = self.$ervBody.find('.tabs').first();

			var url = document.location.toString();

			//hash triumph first tab
			if (url.match('#tab-') && self.$tabs.length > 0) {
				var $hashElement = self.$tabs.find('a[href="#tab-' + url.split('#tab-')[1] + '"]');

				if ($hashElement.length > 0) {
					self.setActiveTabAndContent(self.$tabs, $hashElement);
				}
				self.scrollToTabs('hash');
			} else {
				self.setActiveTabAndContent(self.$tabs, self.$tabs.find('.tabs-container .tabs-menu li a').first());
			}
		};

		self.scrollToTabs = function () {
			if (!self.common.framework.checks.isElementInViewport($('.tabs-container'), $('.tabs-container').height())) {
				$.scrollTo($('#erv-body'), 200, { offset: $('header').height() });
			}
		};

		self.setupTabs = function ($tabs) {
			var $tabContents = $tabs.find('.tab-content');
			$tabContents.each(function () {
				var $content = $(this);

				$content.addClass('hide');
				$content.removeAttr('id');

				$content.find('[href^="#tab-"]').each(function (e) {
					var $link = $(this);

					$link.on('click', function (e) {
						e.preventDefault();
						self.setActiveTabAndContent($tabs, $tabs.find('.tabs-menu a[href="' + $link.attr('href') + '"]'));
						self.scrollToTabs('link');
					})
				});
			});
		};
	}

	Tabs.prototype.init = function () {
		var self = this;

		self.initTabsEventHandlers();
		self.setupHash();
	};

	return Tabs;
});